function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @fileoverview
 * @suppress {checkPrototypalTypes}
 * @license Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt The complete set of authors may be found
 * at http://polymer.github.io/AUTHORS.txt The complete set of contributors may
 * be found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by
 * Google as part of the polymer project is also subject to an additional IP
 * rights grant found at http://polymer.github.io/PATENTS.txt
 */
import { ElementMixin } from './element-mixin.js';
import { dedupingMixin } from '../utils/mixin.js';
import { wrap } from '../utils/wrap.js';
var DISABLED_ATTR = 'disable-upgrade';
export var findObservedAttributesGetter = function findObservedAttributesGetter(ctor) {
  while (ctor) {
    var desc = Object.getOwnPropertyDescriptor(ctor, 'observedAttributes');

    if (desc) {
      return desc.get;
    }

    ctor = Object.getPrototypeOf(ctor.prototype).constructor;
  }

  return function () {
    return [];
  };
};
/**
 * Element class mixin that allows the element to boot up in a non-enabled
 * state when the `disable-upgrade` attribute is present. This mixin is
 * designed to be used with element classes like PolymerElement that perform
 * initial startup work when they are first connected. When the
 * `disable-upgrade` attribute is removed, if the element is connected, it
 * boots up and "enables" as it otherwise would; if it is not connected, the
 * element boots up when it is next connected.
 *
 * Using `disable-upgrade` with PolymerElement prevents any data propagation
 * to the element, any element DOM from stamping, or any work done in
 * connected/disconnctedCallback from occuring, but it does not prevent work
 * done in the element constructor.
 *
 * Note, this mixin must be applied on top of any element class that
 * itself implements a `connectedCallback` so that it can control the work
 * done in `connectedCallback`. For example,
 *
 *     MyClass = DisableUpgradeMixin(class extends BaseClass {...});
 *
 * @mixinFunction
 * @polymer
 * @appliesMixin ElementMixin
 * @template T
 * @param {function(new:T)} superClass Class to apply mixin to.
 * @return {function(new:T)} superClass with mixin applied.
 */

export var DisableUpgradeMixin = dedupingMixin(function (base) {
  /**
   * @constructor
   * @implements {Polymer_ElementMixin}
   * @extends {HTMLElement}
   * @private
   */
  var superClass = ElementMixin(base); // Work around for closure bug #126934458. Using `super` in a property
  // getter does not work so instead we search the Base prototype for an
  // implementation of observedAttributes so that we can override and call
  // the `super` getter. Note, this is done one time ever because we assume
  // that `Base` is always comes from `Polymer.LegacyElementMixn`.

  var observedAttributesGetter = findObservedAttributesGetter(superClass);
  /**
   * @polymer
   * @mixinClass
   * @implements {Polymer_DisableUpgradeMixin}
   */

  var DisableUpgradeClass = /*#__PURE__*/function (_superClass) {
    _inherits(DisableUpgradeClass, _superClass);

    var _super = _createSuper(DisableUpgradeClass);

    function DisableUpgradeClass() {
      var _this;

      _classCallCheck(this, DisableUpgradeClass);

      _this = _super.call(this);
      /** @type {boolean|undefined} */

      _this.__isUpgradeDisabled;
      return _this;
    }

    _createClass(DisableUpgradeClass, [{
      key: "_initializeProperties",
      value: // Prevent element from initializing properties when it's upgrade disabled.

      /** @override */
      function _initializeProperties() {
        if (this.hasAttribute(DISABLED_ATTR)) {
          this.__isUpgradeDisabled = true;
        } else {
          _get(_getPrototypeOf(DisableUpgradeClass.prototype), "_initializeProperties", this).call(this);
        }
      } // Prevent element from enabling properties when it's upgrade disabled.
      // Normally overriding connectedCallback would be enough, but dom-* elements

      /** @override */

    }, {
      key: "_enableProperties",
      value: function _enableProperties() {
        if (!this.__isUpgradeDisabled) {
          _get(_getPrototypeOf(DisableUpgradeClass.prototype), "_enableProperties", this).call(this);
        }
      } // If the element starts upgrade-disabled and a property is set for
      // which an accessor exists, the default should not be applied.
      // This additional check is needed because defaults are applied via
      // `_initializeProperties` which is called after initial properties
      // have been set when the element starts upgrade-disabled.

      /** @override */

    }, {
      key: "_canApplyPropertyDefault",
      value: function _canApplyPropertyDefault(property) {
        return _get(_getPrototypeOf(DisableUpgradeClass.prototype), "_canApplyPropertyDefault", this).call(this, property) && !(this.__isUpgradeDisabled && this._isPropertyPending(property));
      }
      /**
       * @override
       * @param {string} name Attribute name.
       * @param {?string} old The previous value for the attribute.
       * @param {?string} value The new value for the attribute.
       * @param {?string} namespace The XML namespace for the attribute.
       * @return {void}
       */

    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, old, value, namespace) {
        if (name == DISABLED_ATTR) {
          // When disable-upgrade is removed, intialize properties and
          // provoke connectedCallback if the element is already connected.
          if (this.__isUpgradeDisabled && value == null) {
            _get(_getPrototypeOf(DisableUpgradeClass.prototype), "_initializeProperties", this).call(this);

            this.__isUpgradeDisabled = false;

            if (wrap(this).isConnected) {
              _get(_getPrototypeOf(DisableUpgradeClass.prototype), "connectedCallback", this).call(this);
            }
          }
        } else {
          _get(_getPrototypeOf(DisableUpgradeClass.prototype), "attributeChangedCallback", this).call(this, name, old, value,
          /** @type {null|string} */
          namespace);
        }
      } // Prevent element from connecting when it's upgrade disabled.
      // This prevents user code in `attached` from being called.

      /** @override */

    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        if (!this.__isUpgradeDisabled) {
          _get(_getPrototypeOf(DisableUpgradeClass.prototype), "connectedCallback", this).call(this);
        }
      } // Prevent element from disconnecting when it's upgrade disabled.
      // This avoids allowing user code `detached` from being called without a
      // paired call to `attached`.

      /** @override */

    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        if (!this.__isUpgradeDisabled) {
          _get(_getPrototypeOf(DisableUpgradeClass.prototype), "disconnectedCallback", this).call(this);
        }
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return observedAttributesGetter.call(this).concat(DISABLED_ATTR);
      }
    }]);

    return DisableUpgradeClass;
  }(superClass);

  return DisableUpgradeClass;
});